import { URLS, HTTP_METHODS, HEADERS_CONTENT_TYPE } from 'modules/api/constants';
import handleRequest from './common';

export const getMetaData = async ({ cancelFunctions, cancelable = true, envId = null, resellerEnvId = null }) => {
  const reqOptions = {
    url: URLS().META_DATA(),
    method: HTTP_METHODS.GET,
    cancelable,
    ...(envId ? { envId } : false),
    ...(resellerEnvId ? { resellerEnvId } : false),
  };
  return handleRequest(reqOptions, cancelFunctions, 'META_DATA');
};

export const fetchDealBids = async (cancelFunctions, dealId) => {
  const reqOptions = {
    url: URLS().DEAL_LIST_BIDS_DATA_URL(),
    method: HTTP_METHODS.POST,
    data: JSON.stringify({ dealId: [dealId] }),
    showLoader: true,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };
  try {
    const result = await handleRequest(reqOptions, cancelFunctions, 'DEAL_LIST_BIDS_DATA_URL');
    const [bidData] = Object.values(result[dealId]);
    return bidData;
  } catch {
    return [];
  }
};
